import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitLabaratoryResearchDetails = ({
  laboratoryFiles,
  laboratoryResearchesRef,
  handleFileDownload,
}) => {
  if (!Array.isArray(laboratoryFiles) || laboratoryFiles.length === 0)
    return null;

  return (
    <div ref={laboratoryResearchesRef} className="mt-3">
      {laboratoryFiles && laboratoryFiles.length > 0 && (
        <Card className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">Dokumentai</Heading>
          </CardHeader>

          <CardContent className="space-y-4">
            {/* Only ONE file */}
            {laboratoryFiles.length === 1 && (
              <Button
                variant="light"
                onClick={() =>
                  handleFileDownload(
                    'LabaratoryResearch',
                    laboratoryFiles[0].name,
                    laboratoryFiles[0].fileType,
                    laboratoryFiles[0].fileId,
                  )
                }
              >
                <Download />
                Atsisiųsti PDF
              </Button>
            )}

            {/* MULTIPLE files */}
            {laboratoryFiles.length > 1 &&
              laboratoryFiles.map((file, index) => (
                <div key={index} className="flex items-center gap-3">
                  <Button
                    variant="light"
                    onClick={() =>
                      handleFileDownload(
                        'LabaratoryResearch',
                        file.name,
                        file.fileType,
                        file.fileId,
                      )
                    }
                  >
                    <Download />
                    Atsisiųsti PDF
                  </Button>

                  <span>{file.name}</span>
                </div>
              ))}
          </CardContent>

          <CardFooter />
        </Card>
      )}
    </div>
  );
};
